import {
  Component,
  forwardRef,
  ViewChild,
  ElementRef,
  OnInit,
  Output,
  EventEmitter,
  Input,
} from "@angular/core";
import {
  NG_VALUE_ACCESSOR,
  FormBuilder,
  ControlValueAccessor,
  FormGroup,
} from "@angular/forms";
import { Observable } from "rxjs";
import { switchMap, filter, debounceTime, tap, finalize } from "rxjs/operators";
import { ClientSearch } from "../../../model/client-search";
import { ClientService } from "../../../services/client.service";
import { ValidateAutoCompleteSelect } from "../../../validators/autocomplete-select.validator";
import { MatDialog } from "@angular/material";
import { ClientEditDialogComponent } from "../../dialogs/client-edit-dialog/client-edit-dialog.component";

export const CLIENT_AUTOCOMPLETE_VALUE_ACCESSOR: any = {
  provide: NG_VALUE_ACCESSOR,
  useExisting: forwardRef(() => ClientCompleteComponent),
  multi: true,
};

@Component({
  selector: "client-autocomplete",
  providers: [CLIENT_AUTOCOMPLETE_VALUE_ACCESSOR],
  templateUrl: "./client-autocomplete.component.html",
  styleUrls: ["./client-autocomplete.component.css"],
})
export class ClientCompleteComponent implements OnInit, ControlValueAccessor {
  onChange;
  filteredClientSearchFilter: Observable<ClientSearch[]>;
  form: FormGroup;
  clientsSearchFilter: ClientSearch[] = [];
  selecting: boolean;
  loading: boolean;
  @ViewChild("clientsSearchCtrl", { static: false })
  clientsSearchCtrl: ElementRef;
  @Output() clientChange = new EventEmitter();
  @Input() canEdit: boolean = true;
  @Input() readOnly: boolean = false;

  constructor(
    private formBuilder: FormBuilder,
    private clientService: ClientService,
    private dialog: MatDialog
  ) {
    this.form = this.formBuilder.group({
      ClientsSearchCtrl: [null],
    });
  }

  get f() {
    return this.form.controls;
  }

  displayFn(item?: ClientSearch): string | undefined {
    return item ? `${item.BusinessName} [${item.Cuit}]` : undefined;
  }

  getProfileClientSearchPath(): string {
    return "";
  }

  ngOnInit() {
    this.f.ClientsSearchCtrl.valueChanges
      .pipe(
        filter((value) => {
          if (value != null && value !== "" && typeof value === "string") {
            return true;
          } else {
            if (value == null || value === "") {
              this.clientsSearchFilter = [];
            }
            return false;
          }
        }),
        debounceTime(400),
        tap(() => (this.loading = true)),
        switchMap((value) =>
          this.clientService
            .getClientsFromSearch(value)
            .pipe(finalize(() => (this.loading = false)))
        )
      )
      .subscribe((values) => (this.clientsSearchFilter = values));
  }

  get isSelected()  {
    const test =
      this.form.controls.ClientsSearchCtrl.value &&
      typeof this.form.controls.ClientsSearchCtrl.value !== "string";

    return test;
  }

  clientSearchSelected(clientSearch: ClientSearch) {
    this.selecting = true;
    this.form.patchValue({ ClientsSearchCtrl: clientSearch });
    this.onClientSearchChange();
  }

  onClientSearchChange() {
    if (this.onChange) {
      const value = !this.form.valid
        ? null
        : this.form.controls.ClientsSearchCtrl.value;
      this.onChange(value);
      this.clientChange.emit(value);
    }
  }

  writeValue(obj: any): void {
    this.form.patchValue({ ClientsSearchCtrl: obj });
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {}

  setDisabledState?(isDisabled: boolean): void {
    if (isDisabled) {
      this.form.disable();
    }
  }

  edit(): void {
    const dialogRef = this.dialog.open(ClientEditDialogComponent, {
      width: "40%",
      data: !ValidateAutoCompleteSelect(this.form.controls.ClientsSearchCtrl)
        ? this.form.controls.ClientsSearchCtrl.value.Id
        : null,
    });

    dialogRef.afterClosed().subscribe(async (client: ClientSearch) => {
      if (client) {
        this.form.patchValue({ ClientsSearchCtrl: client });
        this.onClientSearchChange();
      }
    });
  }
}
